import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import MenuItem from 'material-ui/Menu/MenuItem';
import Typography from "material-ui/Typography";
import { letterGenreValues } from '../../../constants/LetterAIValues'

const styles = () => ({
  root: {
    position: "relative",
    width: "100%",
  },

  title: {
    fontSize: "13px",
    fontWeight: "bold",
    width: "100%",
    "&::after": {
      position: "relative",
      marginTop: "10px",
      width: "100%",
      borderBottom: "1px solid #D9DBDF",
      content: '""',
      display: "block",
      height: "1px",
      top: "0",
    }
  },

  form: {
    marginTop: "20px",
  },
});

class LetterGenreControl extends React.Component {
  render() {
    const { classes, selectedGenre, disabled } = this.props;

    return (
      <div className={classes.root} style={this.props.style}>
        <Typography
          variant="body2"
          className={classes.title}
        >
          自動生成したいレターのジャンルを選択してください
        </Typography>
        <FormControl fullWidth disabled={disabled} className={classes.form}>
          <Select
            value={selectedGenre}
            onChange={(e) => this.props.handleChange(e, "selected_genre")}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              }
            }}
            classes={{ select: classes.select }}
            fullWidth
            disableUnderline
          >
            {letterGenreValues.map((item, i) => (
              <MenuItem
                key={i + 1}
                value={item.value.toString()}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    )
  }
}

LetterGenreControl.propTypes = {
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  selectedGenre: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(LetterGenreControl);



// WEBPACK FOOTER //
// ./src/components/LetterAutoGenerate/controls/LetterGenreControl.jsx